import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { Col, Row } from "../../../../../../components/Component";
import StepGuideCard from "../../wizard_steps_guide/StepGuide";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { reset_verify_user_kyc_status } from "../../../../../../reducers/dashboard_reducers/user_kyc/verify_user_kyc_status_Slice";
import * as app_consts from "../../../../../../constants/react_app_consts";
import OnboardCompanyStep from "./steps/onboard_company_steps/OnboardCompanyStep";
import OnboardCompanyRepresentativeStep from "./steps/onboard_company_steps/OnboardCompanyRepresentativeStep";

const OnboardCompanyWizardIndex = ({ wizardType }) => {
  const [step, setStep] = useState(1);
  const [wizardData, setWizardData] = useState([]);
  const [uniqueID, setUniqueID] = useState([]);
  const dispatch = useDispatch();

  // Listen to Changes in User KYC Details Reducer
  const verify_user_kyc_status = useSelector((state) => state.verify_user_kyc_status.verify_user_kyc_status);
  //
  useEffect(() => {
    if (verify_user_kyc_status.status === app_consts.SUCCESS)
    {
      setWizardData(verify_user_kyc_status.data);
      dispatch(reset_verify_user_kyc_status());
    }
  }, [verify_user_kyc_status]);

  // Next Step
  const nextStep = () => {
    setStep(step + 1);
  };

  return (
    <>
      <Card className="card-bordered">
        <Row className="g-0 col-sep col-sep-md col-sep-xl">
          <StepGuideCard sentStep={step} wizard_type={wizardType} wizard_title="Onboard Company" />
          <Col className="col-md-8 col-xl-8">
            {step === 1 ? (
              <OnboardCompanyStep togglestep={step} nextStep={nextStep} data={wizardData} setUniqueID={setUniqueID} />
            ) : step === 2 ? (
              <OnboardCompanyRepresentativeStep
                togglestep={step}
                nextStep={nextStep}
                data={wizardData}
                uniqueID={uniqueID}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default OnboardCompanyWizardIndex;
